/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  GREEN_MARKER_COLOR,
  rendererColorCircle,
  rendererIconByName,
  ROW_DELETED_CLASS,
  truthyCellRenderer,
} from '@gh/common-internal-shared';
import { DateTimeTypes, NumberTypes } from '@gh/common-shared';
import {
  buildDateTimeColumn,
  buildNumberColumn,
  LayoutBasedGridDefinition,
} from '@gh/core-ui-grid';
import { ComponentListItem } from '../../resources/component-list-item.model';

@Injectable()
export class ComponentGridDefinition extends LayoutBasedGridDefinition {

  columnDefs = {
    isFormula: {
      cellRenderer: truthyCellRenderer(rendererColorCircle(GREEN_MARKER_COLOR)),
    },
    isPicture: {
      cellRenderer: truthyCellRenderer(rendererColorCircle(GREEN_MARKER_COLOR)),
    },
    isSalesTax: {
      cellRenderer: truthyCellRenderer(rendererIconByName('done')),
    },
    costUpdated: buildDateTimeColumn(DateTimeTypes.Timestamp),
    cost: buildNumberColumn(NumberTypes.Price),
  };

  options = {
    rowClassRules: {
      [ROW_DELETED_CLASS]: ({ data }: { data: ComponentListItem }) => data.active !== true,
    },
    getRowId: (params) => String(params.data.id),
  };
}
